export default __webpack_public_path__ + "static-front/media/StopIcon.ff051be7.svg";